export const normalizeRutInput = (value) => {
  let clean = value.replace(/[^0-9kK]/g, '').toUpperCase();
  clean = clean.slice(0, 9);
  const firstKIndex = clean.indexOf('K');
  if (firstKIndex !== -1) {
    clean =
      clean.slice(0, firstKIndex + 1) +
      clean.slice(firstKIndex + 1).replace(/K/g, '');
  }
  return clean;
};